export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.origin}/`,
    // apiBasePath: `https://365omegaa.com/`,
  },
};
export const LOGIN_PROTECTED = true;
export const BETSLIP_AUTOPRINT_MOBILE = false;
export const BETSLIP_AUTOPRINT_DESKTOP = true;

export const isVegasSupportedDomain = [
  "localhost:8080",
  "localhost:5500",
];

export const isEuroVegasDomain = [
  "localhost:8080",
].includes(location.host);

export const isVegasSupported = isVegasSupportedDomain.includes(location.host);

export const getHeaders = () => {
  return {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  };
};

export const getTextLogo = () => {
  switch (window.location.host) {
    case "kingbast.com":
      return null;
    case "alobast.com":
      return null;
    case "maxb3t.com":
      return "max<i>b3t</i>";
    default:
      return "365";
  }
};

export const getLogo = () => {
  switch (window.location.host) {
    case 'redbet1x2.com':
      return "./img/as.png";
    case 'kingbast.com':
    case 'alobast.com': // Slive logo
      return `data:image/png;base64,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`;
      // return "./img/king-logo.png";
      // return "./img/alo-logo.png";
    default:
      return null;
      // return `data:image/png;base64,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`;
  }
};

export const getTitle = () => {
  switch (location.host) {
    case "kingbast.com":
      return "kingbast";
    case "alobast.com":
      return "alobast";
    case "maxb3t.com":
      return "maxb3t"
    default:
      return "365";
  }
};

export const getPokerUrl = () => {
  if (
    location.host == "swissplay365.com" ||
    location.host == "romaplay365.com"
  ) {
    return "#/";
  }

  return "https://start.pokernex.net";
};
